/// <reference path="../types.d.ts" />

import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { putContext } from './contexts.action';
import { loading, navigateContext } from './ui';
import { cmxLocation, HttpMethods, commonActions } from '@codametrix/ui-common';
const { Eula } = commonActions;

const saveEula = createAction<CMxAPI.Eula>(Eula.SAVE_EULA);

const cancelEula = createAction(
  Eula.CANCEL_EULA,
  (value: boolean) => ({ payload: value, meta: { analytics: true } })
);

const acceptInitial = createAction(
  Eula.ACCEPT_INIT,
  (value: CMxAPI.Eula) => ({ payload: value, meta: { analytics: true } })
);

const getEula = async (userId: number, orgId: number) => {
  const eula = await api<CMxAPI.Eula>({
    endpoint: `/users/eula/v1?userId=${userId}&orgId=${orgId}`
  });

  return { ...eula };
};

type AcceptEulaPayload = {
  eula: CMxAPI.Eula;
  context: CMx.Context;
  homepagePreference?: CMxAPI.Preference;
};
const acceptEula = createAsyncThunk(Eula.ACCEPT_EULA, async (
  payload: AcceptEulaPayload,
  {
    dispatch,
    getState,
    rejectWithValue
  }
): Promise<CMxAPI.User> => {
  dispatch(acceptInitial(payload.eula));
  const user = await api<CMxAPI.User>({
    endpoint: '/users/eula/v1',
    init: {
      method: HttpMethods.POST
    },
    body: payload.eula
  });
  dispatch(saveEula(payload.eula));

  if (payload.context.activeContext?.organizationId) {
    const freshContext = await putContext(
      {
        organizationId: payload.context.activeContext?.organizationId.toString()
      },
      dispatch
    );
    cmxLocation.resetLocation();
    dispatch(loading(false));
    await dispatch(
      navigateContext({
        context: freshContext,
        homepagePreference: payload.homepagePreference
      })
    );
  } else {
    cmxLocation.resetLocation();
  }

  return user;
});

export { getEula, saveEula, acceptEula, cancelEula };
